import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import Button from '../../../../../ui/canon/Button';
import { SendIcon, UploadIcon } from 'lucide-react';

const FileUploadWidget = ({ onAnswer, disabled, accept }) => {
  const intl = useIntl();
  const [file, setFile] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };

  const handleSubmit = () => {
    if (file && !isSubmitting) {
      setIsSubmitting(true);
      // In a real app, we'd upload the file here and get a URL/ID.
      // For now, we just simulate it by sending the file name.
      onAnswer({ value: file.name, fileName: file.name, type: 'file' });
    }
  };

  return (
    <div className="space-y-3">
      <div className="border-2 border-dashed border-succession-border rounded-lg p-6 text-center hover:bg-succession-bg-secondary transition-colors">
        <input
          type="file"
          onChange={handleFileChange}
          accept={accept}
          disabled={disabled || isSubmitting}
          className="hidden"
          id="file-upload"
        />
        <label htmlFor="file-upload" className="cursor-pointer block w-full h-full">
          <UploadIcon className="h-8 w-8 mx-auto text-succession-text-muted mb-2" />
          <span className="text-sm text-succession-text-secondary">
            {file ? file.name : intl.formatMessage({ id: 'succession.plans.widget_click_to_upload' })}
          </span>
        </label>
      </div>
      <Button
        onClick={handleSubmit}
        disabled={!file || disabled || isSubmitting}
        className="w-full"
      >
        <SendIcon className="h-4 w-4 mr-2" />
        {intl.formatMessage({ id: 'succession.plans.widget_submit_answer' })}
      </Button>
    </div>
  );
};

export default FileUploadWidget;
